import { useFileUpload } from '@/hooks/use-file-upload'
import React, { useRef } from 'react'

type Pros = {
  feature: string
  onUpload: (result: { uploadedPath: string; file: File }) => void
  multiple?: boolean
  isPublic?: boolean
}

export const AddImageButton: React.FC<Pros> = ({ feature, onUpload, multiple, isPublic = false }) => {
  const inputFileRef = useRef<HTMLInputElement>(null)
  const { inputFileHandler } = useFileUpload()

  const handleChangeFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) {
      return
    }
    if (!multiple) {
      inputFileHandler(feature, isPublic, e, ['image/jpeg', 'image/png'], onUpload)
      return
    }

    const fileList = e.target.files
    await Promise.all(
      Array.from(fileList).map(file => {
        const oneFileEvent = { target: { files: [file] } } as unknown as React.ChangeEvent<HTMLInputElement>
        return new Promise<void>(resolve => {
          inputFileHandler(feature, isPublic, oneFileEvent, ['image/jpeg', 'image/png'], f => {
            onUpload(f)
            resolve()
          })
        })
      }),
    )
  }

  return (
    <div
      className="add-image-button"
      onClick={() => {
        if (inputFileRef.current) {
          inputFileRef.current.value = ''
          inputFileRef.current.click()
        }
      }}
    >
      <div className="add-upload-place"></div>
      <input type="file" multiple={!!multiple} ref={inputFileRef} onChange={e => handleChangeFile(e)} style={{ display: 'none' }} />
    </div>
  )
}
